/**
 * Markers and popups register a "re-place yourself" callback here, so map-level code
 * (e.g. terrain loading) can refresh every overlay without knowing who owns them.
 */
export interface OverlayRegistry {
  register: (refresh: () => void) => () => void;
  refreshAll: () => void;
}

export function createOverlayRegistry(): OverlayRegistry {
  const callbacks = new Set<() => void>();
  return {
    register(refresh) {
      callbacks.add(refresh);
      return () => void callbacks.delete(refresh);
    },
    refreshAll() {
      for (const refresh of callbacks) refresh();
    },
  };
}
